import axios from "../../utils/axiosConfig";
import { HideMedDTO } from "../../dtos/stockOutMed";

export const hide_medicine = async (med: HideMedDTO ) => {
    const { data } = await axios.put( "/api/pharmacy/medicine/hide", med);
  
    return data;
  };